import React from 'react'
import ReactDOM from 'react-dom/client'
import LandlordApp from './LandlordApp'
import '../index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LandlordApp />
  </React.StrictMode>,
)
